import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type NotFoundRouteProps } from '@tanstack/react-router'

import { ErrorTemplate } from '@/components/templates/Error/ErrorTemplate'

const handleClick = () => {
  globalThis.location.href = '/'
}

export const RouterNotFoundErrorPage: FC<NotFoundRouteProps> = () => {
  const intl = useIntl()

  return <ErrorTemplate title={intl.formatMessage({ id: 'errors.notFound.title' })} onClick={handleClick} />
}
